<template>
  <div class="fade-in-fwd my-project-modal">
    <div class="container mt-5 ml-2">
      <h6 class="font-weight-bold">
        {{ $resourceString["account.Trays.Option.Edit"] }}
      </h6>
      <button
        type="button"
        class="wf-modal-button-close btn button-full"
        @click="closeModal"
      >
      <span
          class="png-icon png-icon-icons-symbols--k-txtclose"
          aria-label="Close modal"
        />
      </button>
    </div>
    <div class="step fade-in-fwd mt-2 mr-3">
      <div class="row">
        <div class="col-sm-12 font-16">
          <label for="">{{ $resourceString["myProject.Project.AddItemModal.ProductStep1.ProjectGridSize.Label"] }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <my-project-radio-field :options="productData.type == 3 ? getContentWizardData.documentRadioOptions : getContentWizardData.radioOptions" name="size" v-model="step2.size"></my-project-radio-field>
        </div>
      </div>
      <div class="form-group mt-2">
        <label for="description" class="gray-bold" v-if="productData.type == 8">
          {{ 
            productData.type == 4 ? $resourceString["contentWizard.AddDocument.Description.Label"] : 
            productData.type == 0 ? $resourceString["myProject.Project.AddItemModal.ProductStep1.ProjectDescription.Label"] : 
            productData.type == 9 ? $resourceString["contentWizard.VirtualTray.TrayDescription.Label"] : 
            productData.type == 10 ? $resourceString["contentWizard.GalleryImages.ImageDescription.Label"] : 
            $resourceString["common.label.description"]  
          }}
          <span class="optional-field ml-3"> {{ $resourceString["contentWizard.Label.Field.Optional"] }} </span>
        </label>
        <my-project-description-field customClass="form-control" maxlength="400" fieldId="description" :placeholder="$resourceString['myProject.ProductItem.Description.Placeholder']" v-model="step2.description" ></my-project-description-field>
      </div>

      <div class="modal-footer border-0 px-0 mt-5">
        <div class="justify-content-between w-100  row">
          <button class="btn btn-outline-primary" @click="closeModal">
            {{ $resourceString["virtualtray.Savetray.Cancel.Button"] }}
          </button>
          <span>
            <button class="btn btn-primary" @click.prevent="updateProjectItem">
              {{ $resourceString["myProject.Project.EditPage.EditSizeAndDesc.Button"] }}
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import myProjectRadioField from "./my-project-radio-field.vue";
import myProjectDescriptionField from "./my-project-description-field.vue";
export default {
  props: ["projectID", "productData"],
  components:{
    myProjectRadioField,
    myProjectDescriptionField
  },
  data() {
    return {
      step2 : {
      boardId: this.projectID,
      title: this.productData.title,
      description: this.productData.description,
      coverPhoto:this.productData.coverPhoto,
      row: this.productData.row,
      column: this.productData.column,
      type: this.productData.type,
      size: this.productData.size,
      link: this.productData.link,
      sectionId: this.productData.sectionId,
      productContentItem: {
        productId: this.productData.productContentItem?.productId,
        installationMethodId: this.productData.productContentItem?.installationMethodId,
        productInventoryType: this.productData.productContentItem?.productInventoryType,
        productType: this.productData.productContentItem?.productType,
        contentItemId: this.productData.productContentItem?.contentItemId,
        productStyleImages: this.productData.productContentItem?.productStyleImages,
        id: this.productData.productContentItem?.id,
      },
      id: this.productData.id,
    },
  }
  },
  computed: {
    ...mapGetters({
      getContentWizardData: "contentWizard/getContentWizardData",
      getisProductSearchDisabled: "contentWizard/getisProductSearchDisabled",
      getproductSearchResponse: "contentWizard/getproductSearchResponse",
      getFilterForProductSearch: "contentWizard/getFilterForProductSearch"
    }),
    getSteps() {
      return this.getContentWizardData.step;
    }
  },
  mounted() {
    this.step2 = {
      boardId: this.projectID,
      title: this.productData.title,
      description: this.productData.description,
      coverPhoto:this.productData.coverPhoto,
      row: this.productData.row,
      column: this.productData.column,
      type: this.productData.type,
      size: this.productData.size,
      link: this.productData.link,
      sectionId: this.productData.sectionId,
      productContentItem: {
        productId: this.productData.productContentItem?.productId,
        installationMethodId: this.productData.productContentItem?.installationMethodId,
        productInventoryType: this.productData.productContentItem?.productInventoryType,
        productType: this.productData.productContentItem?.productType,
        contentItemId: this.productData.productContentItem?.contentItemId,
        productStyleImages: this.productData.productContentItem?.productStyleImages,
        id: this.productData.productContentItem?.id,
      },
      id: this.productData.id,
    };
  },

  methods: {
    ...mapActions({
      updateProductItem: "myProject/updateProductItem",
      resourceString: "myProject/resourceString",
      projectAlreadyExistResourceString:
        "myProject/projectAlreadyExistResourceString"
    }),

    async reloadPage(){
      window.location.reload();
    },

    async updateProjectItem(){
      await this.resourceString(
        this.$resourceString["common.accounts.Updated.Msg"]
      );
      await this.projectAlreadyExistResourceString(
        this.$resourceString["common.accounts.DuplicateName.Msg"]
      );
      await this.updateProductItem(this.step2).then(resp=>{
        if(resp == true){
          this.reloadPage();
          this.closeModal();
        }
      });
    },

    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },

    closeModal() {
      this.hideModal("project-edit-content-item");
    }
  }
};
</script>
